<template>
  <div class="content-wrapper">
    <h1 class="sr-only">Vælg garderobetype</h1>
    <div
      v-if="isDebugMode"
      class="alert alert-info mt-2">
      <label for="importFile">Import from file (For development):</label>
      <input
        type="file"
        id="importFile"
        accept=".json,application/json"
        @change="importFile">
    </div>
    <div class="view-content flex">
      <div class="main-content start-screen py-3 my-auto">
        <validation-observer
          v-if="loaded"
          ref="type-selection-form"
          tag="form"
          class="type-selection-form full-width">

          <div class="form-group m-0 full-width">
            <validation-provider
              rules="required"
              name="wardrobe-position"
              v-slot="{ errors }"
              tag="div"
              class="options-wrapper">
              <c-button
                :class="{
                  'm-3 m-md-2': true,
                  'is-active': data.creatorMode.hasDoor && !data.creatorMode.hasInventory
                }"
                title="Kun skydelåger"
                theme="tile-with-text"
                @click.prevent="confirmSubmitForm(true, false)">
                <img
                  :src="require('@/assets/images/doors-only-thumb.jpg')"
                  alt="Kun skydelåger" />
                <h2 class="c-btn-txt">Kun skydelåger</h2>
              </c-button>

              <c-button
                :class="{
                  'm-3 m-md-2': true,
                  'is-active': data.creatorMode.hasDoor && data.creatorMode.hasInventory
                }"
                title="Garderobe med skydelåger"
                theme="tile-with-text"
                @click.prevent="confirmSubmitForm(true, true)">
                <img
                  :src="require('@/assets/images/full-wardrobe-thumb.jpg')"
                  alt="Garderobe med skydelåger" />
                <h2 class="c-btn-txt">Garderobe med skydelåger</h2>
              </c-button>

              <c-button
                :class="{
                  'm-3 m-md-2': true,
                  'is-active': !data.creatorMode.hasDoor && data.creatorMode.hasInventory
                }"
                title="Kun inventar"
                theme="tile-with-text"
                @click.prevent="confirmSubmitForm(false, true)">
                <img
                  :src="require('@/assets/images/inventory-only-thumb.jpg')"
                  alt="Kun inventar" />
                <h2 class="c-btn-txt">Kun inventar</h2>
              </c-button>
            </validation-provider>
          </div>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import StateUtils from '@/utils/StateUtils.js';

export default {
  name: 'start-screen',
  inject: ['isDebugMode'],
  computed: {
    ...mapGetters('cart', [
      'wardrobeList',
      'activeWardrobeId'
    ]),
  },
  watch: {
    activeWardrobeId () {
      this.loadDataFromStore();
    }
  },
  data () {
    return {
      data: {
        creatorMode: {
          hasDoor: true,
          hasInventory: true
        }
      },
      loaded: false
    }
  },
  mounted () {
    this.loadDataFromStore();
  },
  methods: {
    ...mapActions('cart', ['initNewWardrobe']),
    loadDataFromStore () {
      Vue.set(this, 'loaded', false);

      this.data.creatorMode = { ...this.$store.getters['creator/creatorMode'] };

      Vue.nextTick(() => {
        this.loaded = true;
      });
    },
    confirmSubmitForm (hasDoor, hasInventory) {
      if (!this.activeWardrobeId) {
        this.$store.dispatch('cart/initNewWardrobe');
      }
      this.data.creatorMode = { hasDoor, hasInventory };

      if (this.$store.getters['creator/getIsStepCompleted']('creatorType') && this.areChangesMade()) {
        Vue.swal({
          title: 'Note!',
          text: 'Ændringer i dette trin, kan have indflydelse på senere trin.',
          icon: 'warning',
          confirmButtonText: 'OK',
        }).then(() => {
          this.submitForm();
        });
      } else {
        this.submitForm();
      }
    },
    submitForm () {
      let isSettingChanged = this.areChangesMade();
      if (isSettingChanged) {
        this.$store.commit('creator/resetWardrobe');
        this.$store.commit('creator/resetPrice');
        this.$store.commit('creator/resetInventory');
        this.$store.commit('creator/resetDoors', 0);
        this.$store.commit('creator/resetStepsCompletion');
      }

      Vue.nextTick(() => {
        this.$store.commit('creator/setCreatorMode', this.data.creatorMode);
        this.$store.commit('creator/setStepCompletion', { stepName: 'creatorType', stepCompleted: true });

        this.$router.push({ name: 'wardrobeDimensions' });
      });
    },
    areChangesMade () {
      return StateUtils.isCreatorTypeChanged(this.data, this.$store.getters['creator/creatorWardrobeData']);
    },
    importFile (event) {
      if (!this.isDebugMode) {
        return;
      }
      const file = event.target.files[0];
      if (!file) {
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const fileContent = e.target.result;
          this.$emit('loadStateFromFile', fileContent);
        } catch (error) {
          console.error('Configuration import error:', error);
        }
      };

      reader.onerror = () => {
        console.error('Error reading json filed with configuration');
      };
      reader.readAsText(file);
      event.target.value = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.type-selection-form {
  .options-wrapper {
    align-items: stretch;
    display: flex;
    justify-content: space-evenly;
    width: 100%;

    .c-btn-tile-with-text {
      width: 275px;
      padding: 0;
      height: unset;
    }
  }
}
.wrapper-narrow {
  max-width: 100%!important;
  padding: 0 !important;
}
.buttons-bar {
  height: auto;
  .c-btn {
    text-align: center;
    justify-content: center;
    max-width: 230px;
    width: 100%;
  }
}
@media (max-width: 1240px) {
  .type-selection-form {
    .options-wrapper {
      .c-form-radio {
        width: 225px;
      }
    }
  }
}

</style>
